"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "terranuova-bracciolini": {
    "7b99c584": [{
      "hkey": "b639ce81",
      "slug": "terranuova-bracciolini",
      "name": "Terranuova Bracciolini",
      "primary": true,
      "skipSearch": false
    }],
    "campagna": [{
      "hkey": "b639ce81",
      "slug": "terranuova-bracciolini",
      "name": "Terranuova Bracciolini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5404a4ce": [{
      "hkey": "b80e94f0",
      "slug": "castiglione-ubertini",
      "name": "Castiglione Ubertini",
      "primary": true,
      "skipSearch": false
    }],
    "castiglion-ubertini": [{
      "hkey": "b80e94f0",
      "slug": "castiglione-ubertini",
      "name": "Castiglione Ubertini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d0f62f75": [{
      "hkey": "d4a496f7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "paperina": [{
      "hkey": "d4a496f7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "terranuova-bracciolini"
    }],
    "bbe54563": [{
      "hkey": "d4a496f7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "pernina": [{
      "hkey": "d4a496f7",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "terranuova-bracciolini"
    }],
    "2f7ae5c7": [{
      "hkey": "b639ce81",
      "slug": "terranuova-bracciolini",
      "name": "Terranuova Bracciolini",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-orlandi": [{
      "hkey": "b639ce81",
      "slug": "terranuova-bracciolini",
      "name": "Terranuova Bracciolini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8c64f62": [{
      "hkey": "b639ce81",
      "slug": "terranuova-bracciolini",
      "name": "Terranuova Bracciolini",
      "primary": true,
      "skipSearch": false
    }],
    "riofi": [{
      "hkey": "b639ce81",
      "slug": "terranuova-bracciolini",
      "name": "Terranuova Bracciolini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c9a30c9c": [{
      "hkey": "b639ce81",
      "slug": "terranuova-bracciolini",
      "name": "Terranuova Bracciolini",
      "primary": true,
      "skipSearch": false
    }],
    "setteponti": [{
      "hkey": "b639ce81",
      "slug": "terranuova-bracciolini",
      "name": "Terranuova Bracciolini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "386dee36": [{
      "hkey": "c8179978",
      "slug": "treggiaia",
      "name": "Treggiaia",
      "primary": true,
      "skipSearch": false
    }],
    "treggiana": [{
      "hkey": "c8179978",
      "slug": "treggiaia",
      "name": "Treggiaia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;